<template>
  <tr>
    <td>
      <i v-if="!isMicrosoft"
         :class="`mdi mdi-${itemIcon}`"></i>
      <svgicon v-else
               icon="microsoft-windows"
               width="15"
               height="15"
               color="#707070"></svgicon>
    </td>

    <td>
      {{item.apName}}
    </td>

    <td>
      {{item.clientIdentification ? item.clientIdentification : $t('message.generics.message.notInformed')}}
    </td>

    <td>
      {{ip()}}
    </td>

    <td>
      {{item.macClient}}
    </td>

    <td v-if="!item.sempreLiberado && !item.bloqueado">
      <timer v-bind:endtime="item.expireDate"></timer>
    </td>
  </tr>
</template>

<script>
    import userTableItem from '@views/admin/mixins/user-table-item'
    import timer from '@components/Timer'
    import EventBus from '@packages/event-bus'

    export default {
        components: {
            timer
        },

        data() {
            return {
                entity: 'connections'
            }
        },
        methods: {
            isTabUnknown(){
                return this.$store.state.connections.filters.unknown == true
            },
            releaseConnection(){
                EventBus.$emit('realease-connection', {
                    mac : this.item.macClient,
                    descricao : this.item.emailClient
                })
            },
            ip(){
                return this.item.ipClient ? this.item.ipClient.split('/')[0] : this.$t('message.generics.message.notInformed');
            }
        },

        computed: {
          itemIcon() {
            return {
              0: 'android',
              1: 'apple-ios',
              2: 'microsoft-windows',
              3: 'apple',
              4: 'router-wireless'
            }[this.item.deviceType]
          },
          isMicrosoft() {
            return this.item.deviceType === 2;
          }
        },

        mixins: [userTableItem]
    }
</script>

<style lang="scss" scoped>
@import "~@variables";

svg {
  color: #707070;
}
</style>
